import { useEffect, useState } from "react";
import { useAuthStore } from "../../store/useAuthStore";
import { getEquionSession, switchCompanyApi } from "../../api/auth";
import { queryClient } from "../../queries";

function HandleHissaRedirect({ enabled }: { enabled: boolean }) {
  const accessToken = useAuthStore((state) => state.accessToken);
  const [companyId, setCompanyId] = useState<string | null>(null);

  useEffect(() => {
    if (enabled && companyId && accessToken && getEquionSession())
      switchCompanyApi(companyId)
        .then(() => {
          queryClient.invalidateQueries();
          queryClient.refetchQueries("userContext");
          setCompanyId(null);
        })
        .catch(() => {
          queryClient.refetchQueries("userContext");
        });
  }, [enabled, companyId, accessToken]);

  useEffect(() => {
    const params = window.location.search;
    if (params) {
      const urlSearchParams = new URLSearchParams(params);
      const xUsrToken = urlSearchParams.get("x-usr-token");
      const companyId = urlSearchParams.get("companyId");
      const redirectUri = urlSearchParams.get("redirectURL");
      if (xUsrToken) {
        sessionStorage.setItem("currentUser", xUsrToken);
      }
      if (redirectUri) {
        sessionStorage.setItem("hissaUrl", redirectUri);
      }
      if (companyId) {
        sessionStorage.setItem("companyId", companyId);
        setCompanyId(companyId);
        // Drop the stale, previous session's company immediately so the
        // TopBar doesn't render it while the switch below is in flight.
      }
    }
  }, []);
  return null;
}

export default HandleHissaRedirect;
